import React from 'react';
import classnames from 'classnames';
import { useUniqueId } from '@wix/da-hooks/pkg/useUniqueId';
import s from './LiteratureCoverLetter.scss';
const LiteratureCoverLetter = ({ className , title , isBigEnough , alignment ='end'  })=>{
    const gradientId = useUniqueId();
    const filteredTitle = title && title.replace(/[^a-zA-Z]/g, '');
    if (!filteredTitle || !filteredTitle.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], !isBigEnough && s['letter-scale'], s[alignment], className),
        // This is purely decorative, screen readers don't need it
        "aria-hidden": "true"
    }, /*#__PURE__*/ React.createElement("svg", {
        height: "100%",
        viewBox: "0 0 15 12",
        preserveAspectRatio: "xMidYMin slice",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("linearGradient", {
        x1: "87.8481761%",
        y1: "16.3690766%",
        x2: "45.4107524%",
        y2: "71.4898596%",
        id: gradientId
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#00FF62",
        offset: "0%"
    }), /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#3197EF",
        stopOpacity: "0",
        offset: "100%"
    })), /*#__PURE__*/ React.createElement("text", {
        className: s['letter'],
        fill: `url(#${gradientId})`,
        textAnchor: alignment,
        x: alignment === 'end' ? 15 : 0,
        y: "11"
    }, filteredTitle[0])));
};
LiteratureCoverLetter.displayName = 'LiteratureCoverLetter';
export default LiteratureCoverLetter;
